module.exports = __webpack_public_path__ + "static/50-years-958c501b203387ed9bf9183c1c0c9a11.jpg";